<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
	<roheader :shopcart="shopcart" :shopcart_qty="shopcart_qty" :shopcart_total="shopcart_total"
		@data-updated-shopcart="handleShopcartUpdated"></roheader>
		<!-- 内容 -->
		<!-- <el-button @click="showDialog">打开弹出框</el-button> -->
		<!--    <el-dialog
		         title="提示"
		         :visible.sync="dialogVisible"
		         width="50%"
		         :before-close="handleClose"
		       >
		         <slot>创建成功</slot>
		       </el-dialog> -->

		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page='selected_page'></rosidebar>
				<div style="float: right;width:calc(100% - 269px);overflow: auto;height:1090px;background: white;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						<!-- 您的位置： -->
						<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
						<span style="color:#07ccec;">个人信息</span>
					</h6>
					<el-form :model="new_infor_form" ref="new_infor_form" :rules="rules" label-width="100px" class="demo-ruleForm"
						style="padding-right:20px;">
						<el-form-item label="单位名称" prop="unit_name" style="margin-top: 30px;">
							<el-input v-model="new_infor_form.unit_name"></el-input>
						</el-form-item>		
						<div style="overflow: hidden;">
							<el-form-item label="通讯地址" prop="address" style="float: left;width: 60%;">
								<el-cascader style="width: 100%;" size="large" :options="AreaOptions"
									v-model="selectedArea" @change="handleChangeArea">
								</el-cascader>
							</el-form-item>
							<el-form-item label="邮编" prop="postcode" style="float: right;width: 40%;">
								<el-input v-model="new_infor_form.postcode"></el-input>
							</el-form-item>

						</div>
						<div style="overflow: hidden;">
							<el-form-item label="详细地址" prop="address" style="float: right;width: 100%;">
								<el-input v-model="new_infor_form.address"></el-input>
							</el-form-item>
						</div>
						<div style="overflow: hidden;">
							<el-form-item label="姓名" prop="contact" style="float: left;width: 50%;">
								<el-input v-model="new_infor_form.contact"></el-input>
							</el-form-item>
							<el-form-item label="手机" prop="contact_mobile"  style="float: left;width: 50%;">
								<el-input   disabled v-model="new_infor_form.contact_mobile"></el-input>
							</el-form-item>

						</div>
						<div style="overflow: hidden;">
							<el-form-item label="邮箱" prop="email" style="float: left;width: 50%;">
								<el-input v-model="new_infor_form.email"></el-input>
							</el-form-item>
							<el-form-item label="座机" prop="contact_phone" style="float: left;width: 50%;">
								<el-input v-model="new_infor_form.contact_phone"></el-input>
							</el-form-item>
						</div>
						<!-- 	<div style="overflow: hidden;">
							<el-form-item label="QQ" prop="QQ" style="float: left;width: 33.33%;">
								<el-input v-model="new_infor_form.QQ"></el-input>
							</el-form-item>
							<el-form-item label="邮箱" prop="email" style="float: left;width: 33.33%;">
								<el-input v-model="new_infor_form.email"></el-input>
							</el-form-item>
						</div> -->
					</el-form>
					
					<div style="overflow: hidden;width: 50%;margin:15px auto;">
						<a @click="edit_info" style="font-size: 12px;">
							<button class="vs-btn style2"
								style="border-radius: 10px;height:35px;width: 150px;background-color: red;color:white;padding:0;border-radius: 5px;">确认</button>
						</a>
					</div>
				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	import {
		provinceAndCityData,
		regionData,
		provinceAndCityDataPlus,
		regionDataPlus,
		CodeToText,
		TextToCode
	} from 'element-china-area-data'
	export default {
		name: 'Demo',
		data() {
			return {
				AreaOptions: regionData,
				selected_page:'1-1',
				// selectedArea: ['110000', '110100', '110102'],
				selectedArea: [],
				customer_options: [],
				product_options: [],
				customer_id: [],
				product_ids: [],
				tableData: [],
				tabClickIndex: null,
				tabClickLabel: null,
				// 基本信息数组
				new_infor_form: {
					'unit_name': '',
					'address': '',
					'postcode': '',
					'contact': '',
					'contact_mobile': '',
					'contact_phone': '',
					'default': '',
					'email': ''
				},
				   rules: {
				        unit_name: [{ required: true, message: '单位名称不能为空', trigger: 'blur' }],
				        address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
				        postcode: [{ required: false}],
				        contact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
				        contact_mobile: [{ required: true, message: '手机不能为空', trigger: 'blur' }],
				        contact_phone: [{ required: false}],
				        default: [{ required: false, }],
				        email: [{ required: true, message: '邮箱必填', trigger: 'blur' }],
				      },
				dialogVisible: false,
				shopcart:0,
				shopcart_qty:0,
				shopcart_total:0,
			}
		},
		mounted() {
			this.get_info()
			this.get_shopcart()

			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		
		methods: {
			get_shopcart() {
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == ''||shopcart==null) {
					shopcart = [];
				} else {
					shopcart = JSON.parse(shopcart)
				}
				var shopcart_qty = 0
				var shopcart_total = 0
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total +=parseFloat(shopcart[i].total)
				}
			
				this.shopcart = shopcart
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
			},
			
			handleShopcartUpdated(updatedData) {
				this.shopcart = parseFloat(updatedData).toFixed(2);
			},
			handleShopcartQtyUpdated(updatedData) {
				this.shopcart_qty = parseFloat(updatedData).toFixed(2);;
			},
			handleShopcartTotalUpdated(updatedData) {
				this.shopcart_total = parseFloat(updatedData).toFixed(2);;
			},
			
			handleChangeArea(value) {
				const str = CodeToText[value[0]] + '/' + CodeToText[value[1]] + '/' + CodeToText[value[2]]
				this.new_infor_form.province =  CodeToText[value[0]]
				this.new_infor_form.city =  CodeToText[value[1]]
				this.new_infor_form.area =  CodeToText[value[2]]
				console.log(str)
			
			},
			showDialog() {
				this.dialogVisible = true;
			},
			handleClose(done) {
				var self = this
				this.$confirm('确认修改？')
					.then(_ => {
						self.$message.success('修改成功')
					})
					.catch(_ => {});
			},
			get_info(){
				var self = this
				var data ={
					'id':localStorage.getItem('eshop_user_id')
				}
				fetchPost('/ro/web_eshop/user/detail/v1', data).then(response => {
					console.log(response)
					var now_select_address_info = response.data.detail
					self.new_infor_form.unit_name = now_select_address_info.name
					// debugger
					
					self.new_infor_form.address = now_select_address_info.address.toString()
					self.new_infor_form.postcode = now_select_address_info.postcode.toString()
					self.new_infor_form.contact = now_select_address_info.name.toString()
					self.new_infor_form.contact_phone = now_select_address_info.phone.toString()
					self.new_infor_form.contact_mobile = now_select_address_info.mobile.toString()
					self.new_infor_form.email = now_select_address_info.email.toString()
					if(now_select_address_info.province!=false){
						var province =  TextToCode[now_select_address_info.province].code
						var city =   TextToCode[now_select_address_info.province][now_select_address_info.city].code
						var area =  TextToCode[now_select_address_info.province][now_select_address_info.city][now_select_address_info.area].code
						self.selectedArea = [province,city,area]
						// debugger
						self.new_infor_form.province = now_select_address_info.province
						self.new_infor_form.city = now_select_address_info.city
						self.new_infor_form.area = now_select_address_info.area
					}

					
					
				})
			},
			edit_info() {

				var data = {
					'id': window.localStorage.getItem('eshop_user_id'),
					'unit_name': this.new_infor_form.unit_name,
					'address': this.new_infor_form.address,
					'postcode': this.new_infor_form.postcode,
					'name': this.new_infor_form.contact,
					'phone': this.new_infor_form.contact_phone,
					'email': this.new_infor_form.email,
					'province':this.new_infor_form.province,
					'city':this.new_infor_form.city,
					'area':this.new_infor_form.area,
				}
					  
				var self = this
				this.$refs.new_infor_form.validate(valid => {
				       if (valid) {
				         fetchPost('/ro/web_eshop/user/edit/v1', data).then(response => {
				         	// self.handleClose()
				         self.$message.success('修改成功')
				         })
				       }
					   else{
						   self.$message.error('请完善必填字段')
					   }
				     })
			

			}


		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	.ro-register-input-box {
		width: 60%;
		overflow: hidden;
		line-height: 50px;
		margin: auto;
	}

	.ro-register-input-box span {
		font-weight: 800;
	}

	.ro-register-input {
		border-radius: 10px !important;
		height: 50px !important;
		margin-bottom: 15px;
		width: 80%;
		float: left;
	}

	.vs-btn.style3,
	.vs-btn.style2 {
		margin-left: 0;
	}

	.el-form-item__label {
		font-weight: 500;
		color: #333333 !important;
	}
</style>
